import { render, staticRenderFns } from "./WebpartList.vue?vue&type=template&id=63cf093e"
import script from "./WebpartList.vue?vue&type=script&lang=ts"
export * from "./WebpartList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports